import { render, staticRenderFns } from "./ShopifyConfig.vue?vue&type=template&id=f13031c8"
import script from "./ShopifyConfig.vue?vue&type=script&lang=js"
export * from "./ShopifyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports